// extracted by mini-css-extract-plugin
export default {"container":"MetadataAttribution-container-rF37F","attribution":"MetadataAttribution-attribution-GR45r"};